<template>
  <div
    v-show="showCode && codePath"
    class="modal "
    @mousewheel.prevent
  >
    <!-- @mousewheel.prevent 阻止默认事件 -->
    <div class="modal-inner">
      <div
        class="close-btn cursor"
        @click="$emit('update-show-code',false)"
      >
        <i class="el-icon-close size26"></i>
      </div>
      <h1 class="size20 gray mb10">马上咨询顾问
        <!-- <span class="f12 ml5 cupo" v-clipboard:copy="guid" v-clipboard:success="onCopy" v-clipboard:error="onError" @click="showCodeValue=!showCodeValue">复制二维码</span> -->
      </h1>
      <span class="size14 colb3">打开微信扫一扫，即刻咨询专属顾问</span>
      <div
        class="flex"
        style="margin-top:33px"
      >
        <div
          class="flex1 clum CenterCenter"
          style="border-right: 1px solid #F5F5F5"
        >
          <img
            class="code"
            :src="codePath"
            alt=""
          >
          <!-- <div v-show="showCodeValue" class="guidStyle">{{guid}}</div> -->
        </div>
        <div
          class="flex1"
          style="padding-left:46px"
        >
          <h2 class="black size16 pb7">{{companyConfig.firstName + companyConfig.lastName}}</h2>
          <div>
            <div class="mb10 flex s_center">
              <img
                style="width:16px;height:16px"
                class="pr5"
                src="../assets/icon/web_icon_finish.png"
                alt=""
              >
              <span class="size14 col4d">0佣金</span>
            </div>
            <div class="mb10 flex s_center">
              <img
                style="width:16px;height:16px"
                class="pr5"
                src="../assets/icon/web_icon_finish.png"
                alt=""
              >
              <span class="size14 col4d">真信息</span>
            </div>
            <div class=" flex s_center">
              <img
                style="width:16px;height:16px"
                class="pr5"
                src="../assets/icon/web_icon_finish.png"
                alt=""
              >
              <span class="size14 col4d">放心问</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import parameterServer from "../services/parameterServer.js";
import { mapState } from "vuex";

export default {
  name: "qr-code",
  props: {
    showCode: {
      type: Boolean,
      required: true,
    },
    page: {
      type: Number,
      // required: true
    },
    houseGuid: {
      type: String,
      //   required: true,
    },
    agentGuid: {
      type: String,
      //   required: true,
    },
    tradeType: {
      default: 2,
    },
  },
  computed:{
    ...mapState(["companyConfig"])
  },
  data() {
    return {
      codePath: "",
      guid: "",
      parameter: "",
      showCodeValue: false,
    };
  },
  methods: {
    onCopy() {
      this.$message.success("成功复制到剪切板！");
    },
    // 复制失败时的回调函数
    onError() {
      this.$message.error("复制失败！");
    },
    async getQrCodePath() {
      try {
        let sceneStr = ``;
        switch (this.page) {
          case 13: //二手房
            sceneStr = `houseGuid=${this.houseGuid}&tradeType=${this.tradeType}`;
            break;
          case 8: //新房
            sceneStr = `estateGuid=${this.houseGuid}`;
            break;
          case 11: //经纪人详情
            sceneStr = `agentGuid=${this.agentGuid}`;
            break;
          case 4: //小区详情
            sceneStr = `houseGuid=${this.houseGuid}`;
            break;
        }

        const params = {
          appId: this.companyConfig.appId,
          page: this.page,
          sceneStr: sceneStr,
        };
        const { data } = await parameterServer.loadQrCodePath(params);
        // console.log(`getQrCodePath`, data);
        this.codePath = data.qrCode;
        this.guid = "pages/index/qrCodeLogin?scene=" + data.guid;
        this.parameter = data.parameter;
      } catch(err) {
        console.log('loadQrCodePath :>>',err);
      }
    },
  },
  watch: {
    showCode(val) {
      if (val) {
        this.getQrCodePath();
      }
    },
  },
};
</script>
<style scoped>
.pb7 {
  padding-bottom: 7px;
}
.modal-inner {
  border-radius: 4px;
  background-color: #fff;
  width: 470px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s;
  padding: 36px 47px;
  box-sizing: border-box;
}
.close-btn {
  position: absolute;
  right: 14px;
  top: 18px;
}
.code {
  width: 130px;
  height: 130px;
}

.f12 {
  font-size: 12px;
}
.ml5 {
  margin-left: 5px;
}
.clum {
  display: flex;
  flex-direction: column;
}
.CenterCenter {
  justify-content: center;
  align-items: center;
}
.guidStyle {
  font-size: 12px;
  color: #bbb;
  padding: 5px;
}
</style>